<template>
  <div>
    <site-header>
      <h1>Services</h1>
    </site-header>

    <main :class="$style.services" class="wrap">
      <article :class="$style.item" v-for="item in services">
        <h2 :class="$style.title" v-html="item.title.rendered"></h2>
        <p :class="$style.description">{{ item.acf.description }}</p>
      </article>
    </main>

    <loader v-if="this.loading"></loader>
  </div>
</template>

<script>
  import axios from 'axios';
  import SiteHeader from '../components/SiteHeader';
  import Loader from '../components/Loader';

  export default {
    name: 'services',

    components: {
      SiteHeader,
      Loader,
    },

    head: {
      title() {
        return {
          inner: 'Services',
        };
      },
    },

    data() {
      return {
        loading: true,
        services: [],
      };
    },

    mounted() {
      axios.get('/api/services').then((response) => {
        if (response.data) {
          this.loading = false;
          this.services = response.data;
        }
      });
    },
  };
</script>

<style module lang="postcss">
  .services {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-right: 1rem;
    padding-bottom: 2rem;
    padding-left: 1rem;
    max-width: 62.5em;

    @media (width >= 50em) {
      padding-right: 4rem;
      padding-left: 4rem;
    }
  }

  .item {
    width: 100%;
    margin-bottom: 1rem;
    width: 100%;

    &:last-child {
      margin-bottom: 0;
    }

    @media (width >= 33em) {
      width: calc(50% - 0.5rem);
      margin-bottom: 2rem;

      &:nth-last-child(-n+2) {
        margin-bottom: 0;
      }
    }

    @media (width >= 75em) {
      width: calc(33% - 1rem);

      &:nth-last-child(-n+2) {
        margin-bottom: 0;
      }
    }
  }

  .title {
    margin-bottom: 0.5rem;
    font-size: 1.1rem;
  }

  .description {
    font-size: 0.875rem;
    line-height: 1.5;
  }
</style>



// WEBPACK FOOTER //
// Services.vue?67e3f541